var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99991 4.5C3.99991 3.11929 5.1192 2 6.49991 2H13.4999C14.8806 2 15.9999 3.11929 15.9999 4.5V17.5C15.9999 17.6881 15.8944 17.8602 15.7268 17.9456C15.5592 18.0309 15.3579 18.015 15.2058 17.9044L9.99991 14.1182L4.79399 17.9044C4.6419 18.015 4.4406 18.0309 4.27302 17.9456C4.10543 17.8602 3.99991 17.6881 3.99991 17.5V4.5ZM6.49991 3C5.67148 3 4.99991 3.67157 4.99991 4.5V16.5181L9.70583 13.0956C9.88115 12.9681 10.1187 12.9681 10.294 13.0956L14.9999 16.5181V4.5C14.9999 3.67157 14.3283 3 13.4999 3H6.49991Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.614663b19bc10d9fc060a51d460e8533.svg";
export { ForwardRef as ReactComponent };